import styled from '@emotion/styled';

export const Button = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  width: 30px;
  height: 30px;

  &:focus {
    outline: none;
  }
`;
